export default "__VITE_ASSET__DbjXXgO8__"